import React from 'react'

const CreditLimitSection = ({ card }) => {
  const calculateProgressBarWidth = (card) => {
    if (!card || !Number(card.creditLimit)) return '0%';
    const used = Number(card.creditLimit) - Number(card.avaliableCredit);
    const total = Number(card.creditLimit);
    const percentage = (used / total) * 100;
    return `${percentage}%`;
  }
  return (
    <div className="limit-section" id="card1-limits">
      <div className="limit-header">
        <h3 className="limit-title">Limites do Cartão - {card.isDependent ? "Dependente" : "Titular"}</h3>
        <div className="limit-tag">{card.isDependent ? card.cardholder : "Titular"}</div>
      </div>
      <div className="limit-box">
        <div className="limit-info">
          <div className="limit-label">Limite Total: {Number(card.creditLimit).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
          <div className="limit-values">
            <span>Utilizado: {(Number(card.creditLimit) - Number(card.avaliableCredit)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
            <span>Disponível: {Number(card.avaliableCredit).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
          </div>
        </div>
        <div className="progress-container">
          <div className="progress-bar" style={{ width: calculateProgressBarWidth(card) }}></div>
        </div>
      </div>
    </div>
  )
}

export default CreditLimitSection
